import React from 'react';
import { Link } from 'react-router-dom';
import ChevronRightIcon from 'images/v5/icons/chevron-right.svg';
import { getMenuIcon } from 'utils/getMenuItem';
import styles from './Breadcrumbs.module.scss';
function Breadcrumbs({ items }) {
    return (React.createElement("ul", { className: styles.wrap }, items === null || items === void 0 ? void 0 : items.map((item, index) => {
        var _a, _b;
        const icon = (item === null || item === void 0 ? void 0 : item.to) ? getMenuIcon(item.to) : null;
        const key = (_b = (_a = item.id) !== null && _a !== void 0 ? _a : item.to) !== null && _b !== void 0 ? _b : `${item.name}-${index}`;
        if (item.onClick) {
            return (React.createElement("li", { key: key, className: styles.breadcrumb },
                React.createElement("button", { type: "button", className: styles.link, onClick: item.onClick },
                    icon && React.createElement("span", { className: styles.icon }, icon),
                    item.name),
                index < items.length - 1 && React.createElement(ChevronRightIcon, null)));
        }
        if (!item.to) {
            return (React.createElement("li", { key: key, className: styles.breadcrumb },
                React.createElement("span", { className: styles.link },
                    icon && React.createElement("span", { className: styles.icon }, icon),
                    item.name),
                index < items.length - 1 && React.createElement(ChevronRightIcon, null)));
        }
        return (React.createElement("li", { key: key, className: styles.breadcrumb },
            React.createElement(Link, { className: styles.link, to: item.to },
                icon && React.createElement("span", { className: styles.icon }, icon),
                item.name),
            index < items.length - 1 && React.createElement(ChevronRightIcon, null)));
    })));
}
export default Breadcrumbs;
